<header>
  <h1> <img src="assets/images/logo.png" alt="SOFTBOWL"> </h1>
  <nav class="ff-gnb">
      <ul>
          <li><a href="#">Item List</a></li>
          <li><a href="#">Order</a></li>
          <li><a href="#">Production</a></li>
          <li><a href="#">Packing</a></li>
          <li><a href="#">Expor.Doc</a></li>
          <li><a href="#">Godds Issue</a></li>
          <li><a href="#">Track & Trace</a></li>
          <li><a href="#">Stock Transfer</a></li>
          <li><a href="#">STYLE/SKU</a></li>
          <li><a href="#">User/Org</a></li>
          <li><a href="#"></a></li>
      </ul>
  </nav>
  <div class="user-menu">
      <span>MY INFO</span>
      <span>OMS HELP</span>
      <i class="fas fa-times"></i>
  </div>
</header>

<div class="content-wrap" role="main">
  <app-navigation style="background:#f8f8f8;"></app-navigation>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
